"use client";

import { ChoiceBox } from "../ChoiceBox";
import { TIMELINE_OPTIONS } from "../options";

export function RegisterTimelineStep({
  value,
  onChange,
  onContinue,
}: {
  value: string | null;
  onChange: (value: string) => void;
  onContinue: () => void;
}) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (value) onContinue();
      }}
      // Vertically centred on phones. 134px is the nav (64) plus StepShell's
      // sticky header (~70), both of which sit above this step. min-h so it
      // still grows and scrolls if the options don't fit; symmetric py so the
      // centring isn't skewed.
      className="mx-auto flex min-h-[calc(100dvh-134px)] w-full max-w-[932px] flex-col items-start justify-center gap-6 px-4 py-8 sm:min-h-0 sm:justify-start sm:gap-8 sm:px-6 sm:pb-24 sm:pt-12 lg:pt-[93px]"
    >
      <div className="flex w-full flex-col items-start gap-3 sm:gap-[17px]">
        {/* 28px rather than the 32px used on the shorter headings in this flow:
            this question is ~42 characters, which at 32px runs to four lines on
            a phone and swallows the screen. */}
        <h1 className="font-suisse-intl-bold text-[28px] leading-tight text-white sm:text-5xl lg:text-[64px] lg:leading-[71px]">
          When do you plan to register your business?
        </h1>
        <p className="font-suisse-intl-medium text-base leading-relaxed text-white sm:text-lg sm:leading-[28.8px]">
          A few quick steps, and you&apos;re on your way!
        </p>
      </div>

      <fieldset className="flex w-full flex-col items-start gap-5 sm:gap-8">
        <legend className="sr-only">When do you plan to register your business?</legend>
        {TIMELINE_OPTIONS.map((option) => {
          const selected = value === option.value;

          return (
            <label key={option.value} className="flex w-full cursor-pointer items-start gap-2">
              <input
                type="radio"
                name="register-timeline"
                value={option.value}
                checked={selected}
                onChange={() => onChange(option.value)}
                className="peer sr-only"
              />
              <ChoiceBox selected={selected} />
              <span className="flex-1 font-suisse-intl text-base leading-6 text-white sm:text-lg sm:leading-[28.8px]">
                {option.label}
              </span>
            </label>
          );
        })}
      </fieldset>

      <button
        type="submit"
        disabled={!value}
        // Full-width on phones so the only action on screen isn't a small pill
        // adrift in a left-aligned column.
        className="flex h-12 w-full items-center justify-center rounded-full bg-white px-4 font-suisse-intl text-xl leading-5 text-[#2A4775] transition-opacity hover:opacity-90 disabled:pointer-events-none disabled:opacity-50 sm:w-auto sm:min-w-[160px]"
      >
        Continue
      </button>
    </form>
  );
}


    